import Icon from '@ant-design/icons';

const EpicSvg = (props: any) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.61813 1.01888C6.77319 1.0704 6.87811 1.21805 6.87811 1.38464V4.58975H9.51252C9.65408 4.58975 9.78364 4.67093 9.84787 4.79984C9.9121 4.92875 9.90016 5.08357 9.81691 5.2006L5.80257 10.8416C5.70668 10.9763 5.53682 11.0326 5.38182 10.9811C5.22676 10.9296 5.12184 10.782 5.12184 10.6154V7.41028H2.48743C2.34588 7.41028 2.21629 7.3291 2.15207 7.20018C2.08783 7.07126 2.09981 6.91644 2.18307 6.79941L6.19743 1.15842C6.29327 1.02369 6.46313 0.967361 6.61813 1.01888Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const EpicIcon = (props: any) => <Icon component={EpicSvg} {...props} />;
